export default __webpack_public_path__ + "static/media/mapFrameMediumBlack.e3ddf168.png";